<template>
  <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <div class="content-header">
        
      </div>
      <!-- /.content-header -->

      <!-- Main content -->
      <div class="content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-6">
              <div class="card card-primary card-outline">
                <div class="card-header">
                    <span class="m-0">数据概览</span>
                  </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-sm-3">
                      <div class="info-box bg-info">
                        <div class="info-box-content">
                          <span class="info-box-text text-center">今日订单数</span>
                          <span class="info-box-number text-center mb-0">{{todayData.todayOrder}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-sm-3">
                      <div class="info-box bg-warning">
                        <div class="info-box-content">
                          <span class="info-box-text text-center">今日订单金额</span>
                          <span class="info-box-number text-center mb-0">{{todayData.todayMoney}} <span>
                        </span></span></div>
                      </div>
                    </div>
                    <div class="col-12 col-sm-3">
                      <div class="info-box bg-success">
                        <div class="info-box-content">
                          <span class="info-box-text text-center">全部订单数</span>
                          <span class="info-box-number text-center mb-0">{{todayData.orders}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-sm-3">
                      <div class="info-box bg-danger">
                        <div class="info-box-content">
                          <span class="info-box-text text-center">全部订单金额</span>
                          <span class="info-box-number text-center mb-0">{{todayData.orderMoney}} <span>
                        </span></span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              

              <div class="card card-primary card-outline">
                <div class="card-header">
                  <span class="m-0">数据统计</span>
                </div>
                <div class="card-body nopadding center">
                  <echart
                    :options="polar"
                    autoresize
                  />
                  <a href="javascript:void(0);" @click="currentWeek" class="card-link">近7天</a>
                  <a href="javascript:void(0);" @click="currentMonth" class="card-link">近30天</a>
                </div>
              </div><!-- /.card -->
            </div>
            <!-- /.col-md-6 -->
            <div class="col-lg-6">

              <div class="card card-primary card-outline">
                <div class="card-header">
                    <span class="m-0">设备概览</span>
                  </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-sm-4">
                      <div class="info-box bg-info">
                        <div class="info-box-content">
                          <span class="info-box-text text-center">总设备数</span>
                          <span class="info-box-number text-center mb-0">{{equipmentData.all}} </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-sm-4">
                      <div class="info-box bg-success">
                        <div class="info-box-content">
                          <span class="info-box-text text-center">在线</span>
                          <span class="info-box-number text-center mb-0">{{equipmentData.online}} </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-sm-4">
                      <div class="info-box bg-danger">
                        <div class="info-box-content">
                          <span class="info-box-text text-center">离线</span>
                          <span class="info-box-number text-center mb-0">{{equipmentData.all-equipmentData.online}}<span>
                        </span></span></div>
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>

              <div class="card card-primary card-outline">
                <div class="card-header">
                  <span class="m-0">今日订单</span>
                </div>
                <div class="card-body" style="padding:10px;">
                  <table class="table table-bordered">
                    <thead>                  
                      <tr>
                        <th>设备号</th>
                        <th>用户昵称</th>
                        <th>租借时间</th>
                        <th>消费金额</th>
                        <th>商铺名称</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in listOrder" :key="index">
                        <td>{{item.equipmentNumber}}.</td>
                        <td>{{item.nickName}}</td>
                        <td>{{item.borrowTime}}</td>
                        <td><span class="badge">{{item.spend}}</span></td>
                        <td><span class="badge bg-danger">{{item.merchantName}}</span></td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="d-flex flex-row justify-content-end more">
                    
                      <Pagination layout="pager, total" 
                      :current-page="pager.currentPage" 
                      :page-size="pager.size"
                      :total="pager.total"
                      @current-change="pageClick"
                      ></Pagination>
                  </div>
                </div>
              </div>

            </div>
            <!-- /.col-md-6 -->
          </div>
          <!-- /.row -->
        </div><!-- /.container-fluid -->
      </div>
      <!-- /.content -->
    </div>
    <!-- /.content-wrapper -->
</template>

<script>


import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/polar'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'
import { mapState  } from "vuex";

import { fetchGet, fetchPost } from "@/api/axios_config.js";
import { api, buff } from "@/api/api.js";
import 'element-ui/lib/theme-chalk/index.css';
import { Pagination } from 'element-ui';

export default {
  
  data () {

    return {

      todayData : {
        orders : 0,
        todayOrder : 0,
        orderMoney : 0,
        todayMoney : 0
      },
      equipmentData:{
        all:0,
        online:0,
        offline:0
      },

      listOrder:[],
      pager:{
        pages: 0,
        currentPage: 0,
        total:0,
        size:5
      },

      polar: {
         title: {
          text: '折线图堆叠'
          },
          tooltip: {
              trigger: 'axis'
          },
          legend: {
              data: ['金额', '订单']
          },
          grid: {
              left: '0',
              right: '10',
              bottom: '3%',
              containLabel: true
          },
          toolbox: {
              feature: {
                  saveAsImage: {}
              }
          },
          xAxis: {
              type: 'category',
              boundaryGap: false,
              data: []
          },
          yAxis: {
              type: 'value'
          },
          series: [
              {
                  name: '金额',
                  type: 'line',
                  data: []
              },
              {
                  name: '订单',
                  type: 'line',
                  data: []
              }
          ]
      },

      weekData:[],
      monthData:[]
    }
  },
  methods:{
    async getAllOrders(){
      if(!this.pager.currentPage || this.pager.currentPage == 0){
        this.pager.currentPage = 1;
      }
      let res = await fetchGet(api.getTodayOrders, {current:this.pager.currentPage, 
          pageSize: this.pager.size, openid:this.userId});

      this.listOrder = res.data.records;

      this.listOrder.map(item=>{
        
        switch(item.state){
          case "2":
            item.state = "未归还";
            break;
          case "3":
            item.state = "已归还";
            break;
          case "1":
            item.state = "新建订单";
            break;
        }
        switch(item.orderType){
          case 0:
            item.orderType = "微信";
            break;
          case 1:
            item.orderType = "支付宝";
            break;
          case 2:
            item.orderType = "支付宝预授权";
            break;
          case 3:
            item.orderType = "微信预授权";
            break;
        }
        return {...item}
      })

      this.pager = {
        pages : res.data.pages,
        currentPage : res.data.current,
        total: res.data.total,
        size:res.data.size
      }
    },

    async accountingOrder(){
      let res = await fetchGet(api.accountingOrder, {openid:this.userId});
      let count = res.data;
      this.todayData = {
        orders : count.allCount || 0,
        todayOrder : count.todayCount|| 0,
        orderMoney : count.allSpend|| 0,
        todayMoney : count.todaySpend|| 0
      }
    },
    //设备数量统计
    async accountingEquipment(){

      let res = await fetchGet(api.accountingEquipment, {agentId:this.userId});
      let count = res.data;
      
      console.log(count)
      this.equipmentData = {
        all : count.all || 0,
        online : count.online|| 0,
        offline : count.offline|| 0
      }
      
      if(this.userId == 21){
        this.equipmentData.all += 1;
        this.equipmentData.online += 1;
      }
    },
    
    pageClick(page){
      console.log(page)
      this.pager.currentPage = page;
      this.$loading("加载中...");
      this.getAllOrders();
      this.$loading_close();
    },
    
    async currentWeek(){
      let xAxis = [];
      let dataArray  = [];
      let dataArray1 = [];

      if(this.weekData.length == 0){
        let res = await fetchGet(api.getWeekOrders, {openid:this.userId});
        this.weekData = res.data;
      }
      
      for(var i=0;i<this.weekData.length;i++){
        xAxis.push(this.weekData[i].time);
        dataArray1.push(this.weekData[i].spend );
        dataArray.push(this.weekData[i].count );
      }
      
      this.polar.xAxis.data = xAxis;
      this.polar.series = [{
          name: '金额',
          type: 'line',
          data: dataArray1
      },{
          name: '订单',
          type: 'line',
          data: dataArray
      }]
    },
    async currentMonth(){
      let xAxis = [];
      let dataArray  = [];
      let dataArray1 = [];
      
      if(this.monthData.length == 0){
        let res = await fetchGet(api.getMonthOrders, {openid:this.userId});
        this.monthData = res.data;
      }

      for(var i=0;i<this.monthData.length;i++){
        xAxis.push(this.monthData[i].time);
        dataArray1.push(this.monthData[i].spend );
        dataArray.push(this.monthData[i].count );
      }
      
      this.polar.xAxis.data = xAxis;
      this.polar.series = [{
          name: '金额',
          type: 'line',
          data: dataArray1
      },{
          name: '订单',
          type: 'line',
          data: dataArray
      }]
    },
    showMonthFirstDay(){     
        var Nowdate=new Date();     
        var MonthFirstDay=new Date(Nowdate.getYear(),Nowdate.getMonth(),1);     
        //M=Number(MonthFirstDay.getMonth())+1     
        //return MonthFirstDay.getYear()+"-"+M+"-"+MonthFirstDay.getDate();     
        return Number(MonthFirstDay.getMonth())+1  ;     
    }
  },
  components: {
    echart: ECharts,
    Pagination
  },
  created(){
    this.getAllOrders();
    this.accountingOrder();
    this.accountingEquipment();

    this.currentWeek();
    // let xAxis = [];
    // let dataArray  = [];
    // let dataArray1 = [];
    // for(var i=1;i<30;i++){
    //   xAxis.push('01月' + i+"日");
    //   dataArray1.push(Math.floor(Math.random() * 100) + 100);
    //   dataArray.push(Math.floor(Math.random() * 100));
    // }
    
    // this.polar.xAxis.data = xAxis;
    // this.polar.series = [{
    //               name: '金额',
    //               type: 'line',
    //               data: dataArray1
    //           },{
    //               name: '订单',
    //               type: 'line',
    //               data: dataArray
    //           }]
  },
  computed:{
     ...mapState("userModule", ["userId"])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content-header{padding: 7px 10px;}
.info-box{min-height: 46px;}
.more{padding-top: .5rem;}
.score-wapper{position: relative;}
.score{position:absolute;}
.nopadding{padding:10px;}
.center{text-align: center;}
.echarts{width:100%;min-width:400px;height: 300px;}
    
</style>



// WEBPACK FOOTER //
// src/page/Index/Index.vue